/**
 * @file 内置角色
 * @author lixiaobin
 */

import { postWithJson } from 'library/utils/serviceUtil'

/**
 * 内置角色菜单详情
 * @param {number} params.type 系统内置角色类型 1:管理员 2:普通员工
 */
export const roleDetail = (params = {}) => {
    return postWithJson('/system/role/detail.np', params)
}

/**
 * 设置系统内置角色的菜单
 * @param {number} params.type 系统内置角色类型 1:管理员 2:普通员工
 */
export const set = (params = {}) => {
    return postWithJson('/system/role/set.np', params)
}
